import { setSelectedLocale } from "@/locales/store";
import { DSLanguageSelector } from "@hundred5/design-system";
import { useLingui } from "@lingui/react";
import { capitalize } from "lodash";
import { setUserLocale, trackSwitchLocale } from "../../amplitude";
import { getFormatLocale, messages } from "../../locales";

export function LocaleSelect() {
  const { i18n } = useLingui();

  const locale = i18n.locale || "en";

  const handleChange = (locale: string | null | undefined) => {
    if (locale == null) return;
    i18n.activate(locale);
    setSelectedLocale(locale);

    setUserLocale(locale);
    trackSwitchLocale(locale);
  };

  return (
    <DSLanguageSelector
      selectedLocale={locale}
      locales={locales}
      onChange={(item) => handleChange(item?.locale)}
    />
  );
}

const locales = Object.keys(messages).map((locale) => {
  const formatedLocale = getFormatLocale(locale);

  // @ts-ignore
  const names = new Intl.DisplayNames(formatedLocale, {
    type: "language",
  });

  return {
    locale: locale,
    label: capitalize(names.of(formatedLocale)),
  };
});
